<template>
  <div class="car-slide-component" :style="{backgroundColor: bgColor, paddingTop: title ? '3.42vw' : '6.25vw' }">
    <!-- 标题 -->
    <h3 class="car-slide-title" v-if="title">{{ title }}</h3>
    <!-- 幻灯片区域 -->
    <div class="slideshow-container">
      <!-- 左箭头 -->
      <button class="arrow-btn prev" @click="prev" aria-label="Previous Slide">
        <img :src="leftIcon" alt="prev">
      </button>

      <!-- 第一层：图片展示区 (渐隐渐现) -->
      <div class="image-layer">
        <div
          v-for="(item, index) in slideList"
          :key="index"
          class="slide-image-item"
          :class="{ active: current === index }"
        >
          <img :src="item.img" :alt="item.name" />
        </div>
      </div>

      <!-- 右箭头 -->
      <button class="arrow-btn next" @click="next" aria-label="Next Slide">
        <img :src="rightIcon" alt="next">
      </button>

      <!-- 内容包裹层 (包含导航和描述) -->
      <div class="content-layer">
        
        <!-- 第二层：导航标题 (Flex布局) -->
        <div class="nav-layer">
          <div
            v-for="(item, index) in slideList"
            :key="index"
            class="nav-item"
            :class="{ active: current === index }"
            @click="goTo(index)"
          >
            {{ item.name }}
          </div>
          
          <!-- 底部线条容器 -->
          <div class="line-container">
            <!-- 灰色底線 -->
            <div class="base-line"></div>
            <!-- 黑色高亮线 (绝对定位，动态移动) -->
            <div 
              class="active-line" 
              :style="{ 
                left: activeLineLeft, 
                width: activeLineWidth 
              }"
            ></div>
          </div>
        </div>

        <!-- 第三层：描述内容 (随图片切换) -->
        <div class="desc-layer">
          <div
            v-for="(item, index) in slideList"
            :key="index"
            class="desc-item"
            :class="{ active: current === index }"
          >
            <!-- 使用 v-html 渲染 desc 中的 br 标签 -->
            <div class="desc-text" v-html="item.desc"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'CarSlideComponent',
  props: {
    title: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: '#ffffff'
    },
    slideList: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      leftIcon: '/assets/images/icon-carousel-left-btn.png',
      rightIcon: '/assets/images/icon-carousel-right-btn.png',
      imgUrlPrefix: '/assets/images/car_features/', // 请根据实际路径修改
      current: 0,
      autoPlayTimer: null,
    };
  },
  computed: {
    // 计算高亮线的左侧位置 (百分比)
    activeLineLeft() {
      const count = this.slideList.length;
      const percent = 100 / count;
      return `${this.current * percent}%`;
    },
    // 计算高亮线的宽度 (百分比)
    activeLineWidth() {
      const count = this.slideList.length;
      return `${100 / count}%`;
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    // 上一张
    prev() {
      this.current = (this.current - 1 + this.slideList.length) % this.slideList.length;
      this.resetAutoPlay();
    },
    // 下一张
    next() {
      this.current = (this.current + 1) % this.slideList.length;
      this.resetAutoPlay();
    },
    // 跳转到指定索引
    goTo(index) {
      this.current = index;
      this.resetAutoPlay();
    },
    startAutoPlay() {
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        this.next();
      }, 5000); // 5秒切换一次
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    },
  },
};
</script>

<style lang="less" scoped>
.car-slide-component {
  width: 100%;
  .car-slide-title {
    text-align: center;
    margin-bottom: 1.27vw;
    color: #0A0A0C;
    font-weight: @fw2;
    font-size: clamp(32px, 2.5vw, 48px);
  }
  .slideshow-container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    position: relative;
    overflow: visible;
    /* --- 箭头按钮样式 --- */
    .arrow-btn {
      position: absolute;
      top: 34%;
      // transform: translateY(-60%);
      width: clamp(40px, 3vw, 64px);
      height: clamp(40px, 3vw, 64px);
      cursor: pointer;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.3s;
      // &:hover {
      //   transform: translateY(-50%) scale(1.1);
      // }
      &.prev {
        left: 20px;
      }
      &.next {
        right: 20px;
      }
    }

    /* --- 第一层：图片层 --- */
    .image-layer {
      position: relative;
      width: 100%;
      // height: 500px;
      /* 原始比例 1600x770 ≈ 2.758 */
      aspect-ratio: 1600 / 770; 
      background-color: #f5f5f5;
      margin-bottom: 2.08vw;
      .slide-image-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.8s ease-in-out;
        z-index: 1;
        &.active {
          opacity: 1;
          z-index: 2;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
    }

    /* --- 内容层 (导航 + 描述) --- */
    .content-layer {
      position: relative;
      padding: 0 1.04vw 1.04vw;
      /* --- 第二层：导航层 --- */
      .nav-layer {
        position: relative;
        display: flex;
        justify-content: space-between;
        margin-bottom: 1.04vw;
        cursor: pointer;
        .nav-item {
          flex: 1;
          text-align: center;
          font-weight: @fw2;
          font-size: clamp(16px, 1.25vw, 24px);
          color: rgba(0, 0, 0, 0.7);
          padding: 10px 0;
          transition: color 0.3s ease;
          user-select: none;
          &.active {
            color: #000;
            font-weight: @fw3;
          }
        }
        /* 线条容器 */
        .line-container {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          /* 灰色底线 */
          .base-line {
            width: 100%;
            height: 2px;
            background-color: #e0e0e0;
          }
          /* 黑色高亮线 */
          .active-line {
            position: absolute;
            top: 0;
            height: 2px;
            background-color: #000;
            transition: left 0.4s ease, width 0.4s ease;
            z-index: 2;
          }
        }
      }
    }

    /* --- 第三层：描述层 --- */
    .desc-layer {
      position: relative;
      height: 4.88vw;
      display: flex;
      align-items: center;
      justify-content: center;
      .desc-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        opacity: 0;
        transform: translateY(10px);
        transition: opacity 0.6s ease, transform 0.6s ease;
        pointer-events: none;
        &.active {
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
          z-index: 2;
        }
        .desc-text {
          text-align: center;
          font-size: clamp(14px, 1.04vw, 20px);
          font-weight: @fw2;
          color: rgba(0, 0, 0, 0.5);
          line-height: 1.6;
          max-width: 800px;
          margin: 0 auto;
        }
      }
    }
  }
}


/* 响应式适配 */
// @media (max-width: 768px) {
//   .image-layer {
//     height: 300px;
//   }
  
//   /* 移动端调整箭头位置 */
//   .arrow-btn.prev {
//     top: 150px; /* 300px 的一半 */
//     left: 10px;
//     width: 30px;
//     height: 30px;
//     font-size: 14px;
//   }
  
//   .arrow-btn.next {
//     top: 150px;
//     right: 10px;
//     width: 30px;
//     height: 30px;
//     font-size: 14px;
//   }

//   .nav-item {
//     font-size: 12px;
//   }
  
//   .desc-layer {
//     height: auto;
//     min-height: 80px;
//     margin-top: 20px;
//   }
  
//   .desc-item {
//     position: relative;
//     opacity: 1;
//     transform: none;
//     display: none;
//   }
  
//   .desc-item.active {
//     display: block;
//   }
// }
</style>